import script from "./TaskPickerIgnis.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskPickerIgnis.vue?vue&type=script&setup=true&lang=js"

import "./TaskPickerIgnis.vue?vue&type=style&index=0&id=45acf37c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45acf37c"]])

export default __exports__